import React from "react"
import MoreBenefitsImg from "../../images/MoreBenefits.svg"

const MoreBenefits = () => {
  return (
    <section className="container mx-auto px-6 py-20">
      <h3 className="text-7xl font-light pb-8 leading-tight text-center">
        <span className="text-secondary font-bold block">More </span> benefits
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 text-center text-2xl">
        <div className="border-gray-800 border-8 rounded-3xl px-6 py-20">
          <b>Loyalty</b> Bonus
        </div>
        <div className="border-gray-800 border-8 rounded-3xl px-6 py-20">
          <b>Referral</b>  Bonuses
        </div>
        <div className="border-gray-800 border-8 rounded-3xl px-6 py-16">
          <b>3-week</b>  vacation
        </div>
        <div className="border-gray-800 border-8 rounded-3xl px-6 py-20">
          <b>Paid</b> internet
        </div>
        <div className="border-gray-800 border-8 rounded-3xl px-6 py-20">
          <b>Prepaid</b> medicine
        </div>
        <div className="place-self-stretch px-6 hidden md:block">
          <img
            src={MoreBenefitsImg}
            alt="Avalith Time"
            className="mx-auto"
            width="192"
          />
        </div>
      </div>
    </section>
  )
}

export default MoreBenefits
